import { render, staticRenderFns } from "./debug-tabs.vue?vue&type=template&id=34d4790e&scoped=true&"
import script from "./debug-tabs.vue?vue&type=script&lang=js&"
export * from "./debug-tabs.vue?vue&type=script&lang=js&"
import style0 from "./debug-tabs.vue?vue&type=style&index=0&id=34d4790e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d4790e",
  null
  
)

export default component.exports